import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DefaultEmptyImg from './defaultEmpty';
import SimpleEmptyImg from './simpleEmpty';
import classNames from 'classnames';
import { WebUI } from "../../wui-core/src/index.js";
var defaultEmptyImg = /*#__PURE__*/React.createElement(DefaultEmptyImg, null);
var simpleEmptyImg = /*#__PURE__*/React.createElement(SimpleEmptyImg, null);
var defaultProps = {
  clsPrefix: "u-empty",
  image: defaultEmptyImg,
  description: "暂无数据",
  imageStyle: {}
};
var Empty = (_dec = WebUI({
  name: "empty",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Empty, _Component);

  var _super = _createSuper(Empty);

  function Empty() {
    _classCallCheck(this, Empty);

    return _super.apply(this, arguments);
  }

  _createClass(Empty, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          description = _this$props.description,
          image = _this$props.image,
          imageStyle = _this$props.imageStyle,
          children = _this$props.children,
          className = _this$props.className;
      var alt = typeof description === 'string' ? description : 'empty';
      var imageNode = typeof image === 'string' ? /*#__PURE__*/React.createElement("img", {
        alt: alt,
        src: image
      }) : image;
      return /*#__PURE__*/React.createElement("div", {
        role: "emnpty",
        className: classNames("".concat(clsPrefix), className)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-image"),
        style: imageStyle
      }, imageNode), description && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-description")
      }, description), children && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-footer")
      }, children));
    }
  }]);

  return Empty;
}(Component)) || _class);
;
export default Empty;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-empty/src/Empty.js